import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import clsx from 'clsx';

const useStyles = makeStyles({
  paper: {
    padding: '1rem',
    border: '1px solid lightgray',
  },
});

const ContentWrapper = ({ children, className }) => {
  const classes = useStyles();
  return (
    <Paper elevation={0} className={clsx(classes.paper, className)}>
      {children}
    </Paper>
  );
};

ContentWrapper.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
};

ContentWrapper.defaultProps = {
  children: undefined,
  className: '',
};

export default ContentWrapper;
